import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "dropzone-drop-indicator"
};
const _hoisted_2 = {
    key: 0,
    class: "dropzone-card-indicator"
};
const _hoisted_3 = { class: "text-muted mt-tiny" };
const _hoisted_4 = {
    key: 1,
    class: "icon-file-upload text-primary icon-3x"
};
const _hoisted_5 = {
    key: 1,
    class: "dropzone-placeholder"
};
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { amplitudeService } from '@/models/amplitude-service';
export default /*@__PURE__*/ _defineComponent({
    __name: 'dropzone',
    props: {
        empty: { type: Boolean, default: false },
        showIndicator: { type: Boolean, default: true },
        card: { type: Boolean, default: false }
    },
    emits: ['drop'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const route = useRoute();
        const props = __props;
        const state = ref('idle');
        const root = ref(null);
        function fileDragEnter(event) {
            event.preventDefault();
            event.stopPropagation();
            if (!event.dataTransfer || !event.dataTransfer.items || !event.dataTransfer.items.length) {
                return;
            }
            for (const item of event.dataTransfer.items) {
                if (item.kind !== 'file') {
                    return;
                }
            }
            state.value = 'over';
        }
        function fileDragOver(event) {
            event.preventDefault();
            event.stopPropagation();
        }
        function fileDragLeave(event) {
            var _a;
            event.preventDefault();
            event.stopPropagation();
            // Dragging onto a child element fires a leave for the element behind it, so the
            // zone is only really left when the drag moved outside of it (or off the window,
            // where there is no related target at all).
            const target = event.relatedTarget;
            if (target && ((_a = root.value) === null || _a === void 0 ? void 0 : _a.contains(target))) {
                return;
            }
            state.value = 'idle';
        }
        function fileDrop(event) {
            var _a;
            event.preventDefault();
            event.stopPropagation();
            if (!event.dataTransfer || !event.dataTransfer.files || !event.dataTransfer.files.length) {
                return;
            }
            const validFiles = [];
            for (const file of event.dataTransfer.files) {
                if (file.size <= 0) {
                    continue;
                }
                // Folder
                if (file.size % 4096 === 0 && file.name === '.') {
                    continue;
                }
                validFiles.push(file);
            }
            if (validFiles.length) {
                amplitudeService.trackEvent('[Frontend] User Uploaded File', { method: 'drag_and_drop', page: (_a = route.name) === null || _a === void 0 ? void 0 : _a.toString() });
                emit('drop', validFiles);
            }
            state.value = 'idle';
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "root",
                ref: root,
                class: _normalizeClass([{ 'dropzone--over': state.value === 'over', 'dropzone--card': __props.card }, "dropzone"]),
                onDragenter: fileDragEnter,
                onDragleave: fileDragLeave,
                onDragover: fileDragOver,
                onDrop: fileDrop
            }, [
                (state.value === 'over')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (__props.card)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _cache[0] || (_cache[0] = _createElementVNode("i", { class: "icon-file-upload dropzone-card-indicator__icon" }, null, -1)),
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('document.fields.upload_document_here')), 1),
                                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('fields.max_file_size')), 1)
                            ]))
                            : (__props.showIndicator)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                                : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (props.empty)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("i", { class: "icon-files-empty icon-3x" }, null, -1)
                        ]))]))
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default")
            ], 34));
        };
    }
});
